module.exports = __webpack_public_path__ + "img/games-24.440ce468.webp";